module.exports = __webpack_public_path__ + "signup_step_lollipop_1.90c891c198497910243c4069b69c93db.jpg";